import request from '@/utils/request'
//获取课程详情（包括直播课和录播课）
export function api_courseInfoDetails(params){
  return request({
    url: '/publicszoneui.service/CourseService/CourseInfoDetails',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 课程评论
export function api_courseCommentList(params){
  return request({
    url: '/publicszoneui.service/CourseService/courseCommentList',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 课程章节
export function api_courselChapter(params){
  return request({
    url: '/publicszoneui.service/CourseService/courselChapter',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 直播课预约
export function api_courseSubscribe(data){
  return request({
    url: '/publicszoneui.service/CourseService/save',
    method: 'post',
    data
  })
}
